import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

interface InfiniteScrollObserverProps {
  getRecords: () => void;
  hasMore: boolean;
  children: React.ReactNode;
  loader: React.ReactNode;
}

const InfiniteScrollObserver: React.FC<InfiniteScrollObserverProps> = ({
  getRecords,
  hasMore,
  children,
  loader,
}) => {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasMore) {
      getRecords();
    }
  }, [inView, hasMore, getRecords]);

  return (
    <>
      {children}
      {hasMore && (
        <div ref={ref} style={{ textAlign: "center", padding: "10px" }}>
          {loader}
        </div>
      )}
    </>
  );
};

export default InfiniteScrollObserver;
